var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGroupProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.03602 2.67865C8.03602 4.15792 6.83663 5.35731 5.35736 5.35731C3.8781 5.35731 2.67871 4.15792 2.67871 2.67865C2.67871 1.19939 3.8781 0 5.35736 0C6.83663 0 8.03602 1.19939 8.03602 2.67865Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.3217 2.67865C22.3217 4.15792 21.1223 5.35731 19.643 5.35731C18.1637 5.35731 16.9644 4.15792 16.9644 2.67865C16.9644 1.19939 18.1637 0 19.643 0C21.1223 0 22.3217 1.19939 22.3217 2.67865Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.8572 15.595V12.9163C17.8572 12.5 17.6782 12.0831 17.3213 11.8452C16.6071 11.2499 15.6543 10.833 14.7022 10.5951C14.0474 10.4167 13.2736 10.2377 12.4999 10.2377C11.7856 10.2377 11.0119 10.3572 10.2976 10.5951C9.34545 10.833 8.45217 11.3094 7.67843 11.8452C7.32159 12.1426 7.14258 12.5 7.14258 12.9163V15.595H17.8572Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.1786 6.84534C15.1786 8.32461 13.9792 9.52342 12.4999 9.52342C11.0207 9.52342 9.82129 8.32461 9.82129 6.84534C9.82129 5.36607 11.0207 4.16669 12.4999 4.16669C13.9792 4.16669 15.1786 5.36607 15.1786 6.84534Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.4639 7.67852C23.7497 7.0832 22.7969 6.66627 21.8447 6.42838C21.1899 6.24995 20.4162 6.07153 19.6425 6.07153C18.9282 6.07153 18.1545 6.19048 17.4402 6.42838C17.0828 6.54732 16.7259 6.66629 16.3685 6.84529V6.90476C16.3685 7.9164 15.9522 8.86916 15.2974 9.52338C16.4279 9.8808 17.3213 10.3572 18.0355 10.8924C18.2139 11.0714 18.3924 11.1904 18.5113 11.4283H24.9998V8.74962C24.9998 8.3333 24.8208 7.91641 24.4639 7.67852Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.96426 10.8924C7.79747 10.2971 8.75025 9.82133 9.70241 9.52338C9.04762 8.80911 8.63128 7.9164 8.63128 6.90476C8.63128 6.84529 8.63128 6.8453 8.63128 6.78582C8.27385 6.66629 7.917 6.48785 7.55958 6.42838C6.90478 6.24995 6.13105 6.07153 5.35731 6.07153C4.64304 6.07153 3.86931 6.19048 3.15504 6.42838C2.20287 6.72575 1.30959 7.14267 0.535852 7.67852C0.179008 7.91641 0 8.3333 0 8.74962V11.4283H6.42901C6.60743 11.1904 6.72636 11.0714 6.96426 10.8924Z",
    fill: "#E9E9F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupProfile);
export default __webpack_public_path__ + "static/media/icon-group-profile.5e107f7779d4559b7d60c24259f9abdf.svg";
export { ForwardRef as ReactComponent };